import React, { useState, useRef } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import axios from "axios";
import JoditEditor from "jodit-react";

const CreateBlog = () => {
  const [formData, setFormData] = useState({
    title: "",
    top_description: "",
    bottom_description: "",
    image_url: null,
    publisher_name: "",
    publication_date: "",
  });

  const topEditor = useRef(null);
  const bottomEditor = useRef(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = new FormData();
    dataToSend.append("title", formData.title);
    dataToSend.append("top_description", formData.top_description);
    dataToSend.append("bottom_description", formData.bottom_description);
    dataToSend.append("publisher_name", formData.publisher_name);
    dataToSend.append("publication_date", formData.publication_date);

    if (formData.image_url) {
      dataToSend.append("image_url", formData.image_url);
    }

    try {
      const response = await axios.post(
        "https://kariyer.biyomed.net/api/admin/addNewBlog",
        dataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        },
      );
      console.log("Success:", response.data);
      alert("Blog başarıyla eklendi!");

      setFormData({
        title: "",
        top_description: "",
        bottom_description: "",
        image_url: null,
        publisher_name: "",
        publication_date: "",
      });
      window.location.href="/admin/admin-journals";
    } catch (error) {
      console.error("Error:", error);
      alert("Blog eklenemedi.");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Blog Ekle
        </Typography>
        <p style={{color:"red",fontSize:"12px"}}> <b>*TextEditöre kopyalanan kısmı yapıştıtırken (Your code is similar to HTML. Keep as HTML?) pop-up ile karşılaşıyorsanız  Keep seçeneğini seçiniz.</b></p>
        <p style={{color:"red",fontSize:"12px"}}> <b>*Blogda resim kullanılmayacaksa Üst açıklama ya da Alt açıklamalardan birine tüm yazı yazılabilir. Bu kısım resimin pozisyonu ile alaklıdır </b></p>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Başlık"
            name="title"
            value={formData.title}
            onChange={handleChange}
            margin="normal"
            required
          />

          <Typography variant="h6" sx={{ mt: 2 }}>
            Üst Açıklama
          </Typography>
          <JoditEditor
            ref={topEditor}
            defaultValue={formData.top_description}
            onChange={(newContent) =>
              setFormData((prev) => ({
                ...prev,
                top_description: newContent,
              }))
            }
          />

          <Typography variant="h6" sx={{ mt: 7 }}>
            Alt Açıklama
          </Typography>
          <JoditEditor
            ref={bottomEditor}
            defaultValue={formData.bottom_description}
            onChange={(newContent) =>
              setFormData((prev) => ({
                ...prev,
                bottom_description: newContent,
              }))
            }
          />

          <Typography variant="h6" sx={{ mt: 7 }}>
            Görsel Yükle (800x300 formatında olmalıdır)
          </Typography>
          <p style={{color:"red",fontSize:"12px"}}> <b>*Boyut resmin ekranda uygun gözükmesi içindir herhangi bir boyutta eklenebilir ancak eklendikten sonra kontrol edilmelidir</b></p>
          <input
            type="file"
            name="image_url"
            onChange={handleFileChange}
            accept="image/*"
          />

          <Typography variant="h6" sx={{ mt: 7 }}>
            Yazar
          </Typography>
          <TextField
            fullWidth
            label="Yazar"
            name="publisher_name"
            value={formData.publisher_name}
            onChange={handleChange}
            margin="normal"
            required
          />

          <Typography variant="h6" sx={{ mt: 7 }}>
            Yayın Tarihi
          </Typography>
          <TextField
            fullWidth
            label="Yayın Tarihi"
            name="publication_date"
            type="date"
            value={formData.publication_date}
            onChange={handleChange}
            margin="normal"
            required
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Gönder
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default CreateBlog;
